const statusTypes = [
  { name: "all", color: "var(--primary-color)" },
  { name: "success", color: "var(--success-color)" },
  { name: "error", color: "var(--error-color)" },
];

export default statusTypes;
